import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "7 7 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.25 16.75V24H16.75V16.75H24V15.25H16.75V8H15.25V15.25H8V16.75H15.25Z", fill: "black" }));
export default SvgAdd;
